import { crc16xmodem } from 'crc'
import * as cmd from './command-constants'
import type { Commands } from './types'

export const sendFile = (fileName: string, contents: string): Commands =>
    [
        cmd.filetype,
        `${cmd.fileName}"${fileName}"`,
        `${cmd.fileSize}${contents.length}`,
        `${cmd.crc}${crc16xmodem(contents)}`,
        // not sure if this is needed for all of them
        cmd.reboot,
        `${cmd.data}${contents}`,
    ] as Commands
